import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function ReviewSlide({ className, project, text, author, role }) {
  return (
    <div className={classNames('slide', className)}>
      <blockquote>
        <p className="text">{text}</p>
        <span className="title">{project}</span>
        <figcaption>
          <cite className="author">{author}</cite>
          <span className="role">{role}</span>
        </figcaption>
      </blockquote>
      <style jsx>{styles}</style>
    </div>
  )
}

ReviewSlide.propTypes = {
  className: PropTypes.string,
  project: PropTypes.string,
  text: PropTypes.string,
  author: PropTypes.string,
  role: PropTypes.string
}

ReviewSlide.defaultProps = {
  className: null,
  project: '',
  text: '',
  author: '',
  role: ''
}

ReviewSlide = chainDecorators(decorators, ReviewSlide)

export default ReviewSlide
